import { TongyongGuanbiXian, TongyongJiantou1You } from '@sirius/icons';
import styles from './index.module.scss';
import React, { useCallback, useEffect, useState } from 'react';
import { api, apis, getIn18Text } from 'api';
import classnames from 'classnames';
import useMsgRenderCallback from '@web-common/hooks/useMsgRenderCallback';
const mailApi = api.requireLogicalApi(apis.mailApiImpl);
const edmApi = api.requireLogicalApi(apis.edmSendBoxApiImpl);
const SubjectHelper = (props) => {
    const { onClose, loading, onVisibleSubjectHelper, onClickAiPolish } = props;
    const [aiCount, setAiCount] = useState(0);
    const aiPolish = useCallback(async () => {
        if (loading) {
            return;
        }
        await onClickAiPolish();
    }, [loading]);
    const getAiCount = useCallback(async () => {
        try {
            let res;
            if (process.env.BUILD_ISEDM) {
                res = await edmApi.getGPTQuota();
            }
            else {
                res = await mailApi.getGPTQuota();
            }
            setAiCount(res.dayLeft);
        }
        catch (error) {
            console.error('getAiCount error', error);
        }
    }, []);
    useEffect(() => {
        getAiCount();
    }, []);
    useMsgRenderCallback('aiTimesUpdate', () => {
        getAiCount();
    });
    return (React.createElement("div", { className: styles.subjectHelperWrap },
        React.createElement("div", { className: styles.closeWrap, onClick: onClose },
            React.createElement(TongyongGuanbiXian, { className: styles.icon, wrapClassName: styles.iconWrap })),
        React.createElement("div", { className: styles.textWrap },
            React.createElement("span", { className: styles.txt }, getIn18Text('YOUJIANZHUTIXUYRS？SSSRZTHDJ')),
            React.createElement("span", { className: classnames(styles.blueTxt, {
                    [styles.disable]: loading,
                }), onClick: aiPolish },
                React.createElement("span", null, getIn18Text('AIRUNSEZHUT')),
                React.createElement(TongyongJiantou1You, { className: styles.icon, wrapClassName: styles.iconWrap })),
            React.createElement("span", { className: styles.count }, getIn18Text('JINRIAISHENGYKYCS：', { count: aiCount })))));
};
export default SubjectHelper;
